export default {
    buttons: {
        back: "Indietro",
        next: "Prossimo",
        submit: "Invia"
    }
}